import { render } from "./DashboardIndex.vue?vue&type=template&id=fbfa20ce&scoped=true"
import script from "./DashboardIndex.vue?vue&type=script&lang=js"
export * from "./DashboardIndex.vue?vue&type=script&lang=js"

import "./DashboardIndex.vue?vue&type=style&index=0&id=fbfa20ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfa20ce"]])

export default __exports__